<template>
  <div>
    <Head title="Create Mail Template" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/mail">Mail Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">PDF Upload</li>
      </ol>
    </nav>
    <h1>PDF Upload</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <text-input v-model="form.name" :error="form.errors.name" label="Name" />

        <input type="file" name="file" class="form-control" @input="form.file = $event.target.files[0]" />
        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Upload PDF</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    TextInput,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    mailtemplates: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        file: null
      }),
    }
  },
  methods: {
    onChangeFile(event) {
      //this.$emit('update:modelValue', event.target.files[0])

      //this.form.file = event.target.files[0]
    },
    store() {
      this.form.post('/settings/mail/pdfs')
    }
  }
}
</script>
